import React, { useState, useEffect } from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { DialogActions } from "@material-ui/core";
import { onPreventEnterSubmitting, setObject } from "../../../../utils/utils";
import {
  saveOutlet,
  getOutlet,
  getOutletMasterDataAPI,
} from "../../../../services/sales/outletService";
import { Card } from "react-bootstrap";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import store from "../../../../store/store";
import { DateTime } from "luxon";
import {
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import MapPlaces from "../../../../partials/content/MapPlaces";
import DialogLayout from "../../../../partials/content/DialogLayout";
const OutletForm = ({ outlet, onCloseDialog, onReloadOutlets }) => {
  const [auth, setAuth] = useState({});
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [openSearchMapPlaces, setOpenSearchMapPlaces] = useState(false);
  const { socket, companyProfile } = useGlobalData();
  const [outletData, setOutletData] = useState({
    ID: 0,
    appCode: "OUTL",
    approvalLvl: 0,
    currencyID: 0,
    outletName: "",
    addressPhone: "",
    addressEmail: "",
    address: "",
    city: "",
    province: "",
    countryCode: companyProfile.countryCode,
    postalCode: "",
    thermalPrinterSizeID: 80,
    thermalPrinterSizeName: "",
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });
  useEffect(() => {
    const { auth } = store.getState();

    function getOutletData() {
      getOutlet(outlet.ID).then((response) => {
        const { data, auth } = response.data;
        const { outlet: outletData, currencies, countries } = data;
        setMasterData(currencies, countries);
        setOutletData(outletData);
        setAuth(auth);
      });
    }
    function getOutletMasterData() {
      getOutletMasterDataAPI().then((response) => {
        const { data, auth } = response.data;
        const { currencies, countries } = data;
        setMasterData(currencies, countries);
        setAuth(auth);
      });
    }

    getOutletMasterData();

    if (outlet && outlet.ID > 0) {
      setObject(socket, "lock", outlet.ID, "OUTL", auth.user)
        .then((response) => {
          getOutletData();
        })
        .catch((error) => {
          onCloseDialog();
        });
    }
    return () => {
      if (outlet && outlet.ID > 0) {
        setObject(socket, "release", outlet.ID, "OUTL", auth.user);
      }
    };
  }, [outlet]);

  const outletFormSchema = yup.object().shape({
    ID: yup.number().default(outletData.ID),
    currencyID: yup
      .number()
      .required("Currency is required")
      .moreThan(0, "Currency is required"),
    outletName: yup
      .string()
      .required("Outlet Name is required")
      .max(255, "Outlet Name maximum characters is 255"),
    addressPhone: yup
      .string()
      .required("Phone Number is required")
      .matches(
        /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
        "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
      )
      .max(50, "Phone Number maximum characters is 50"),
    addressEmail: yup
      .string()
      .email("Email must be valid. e.g. joe@invifo.com")
      .required("Email is required")
      .max(50, "Email maximum characters is 50"),
    address: yup
      .string()
      .required("Address is required")
      .max(255, "Address maximum characters is 255"),
    city: yup
      .string()
      .required("City is required")
      .max(50, "City maximum characters is 50"),
    province: yup.string().max(50, "Province maximum characters is 50"),
    countryCode: yup.string(),
    postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
    thermalPrinterSizeID: yup
      .number()
      .required("Thermal Printer Size is required")
      .moreThan(0, "Thermal Printer Size is required"),
  });
  return (
    <Formik
      initialValues={outletData}
      validationSchema={outletFormSchema}
      enableReinitialize={true}
      onSubmit={async (values, { setStatus, setSubmitting }) => {
        Swal.mixin({
          customClass: {
            confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
          },
          buttonsStyling: false,
        })
          .fire({
            title: "Are you sure want to save this Outlet ?",
            text: "Please note that you are responsible for this action",
            icon: "question",
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
            cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              saveOutlet(values).then((response) => {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Saved",
                  html: response.data.message,
                  icon: "success",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
                onReloadOutlets();
              });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
              Swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                },
                buttonsStyling: false,
              }).fire({
                title: "Cancelled",
                text: "No change has been made",
                icon: "info",
                showCloseButton: true,
                confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
              });
            }
          });
      }}
    >
      {({
        values,
        status,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        setFieldValue,
        isSubmitting,
      }) => (
        <form
          noValidate={true}
          autoComplete="off"
          className="kt-form"
          onSubmit={handleSubmit}
          onKeyDown={onPreventEnterSubmitting}
        >
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12">
              <Card>
                <Card.Header>
                  <i className="fas fa-th-large"></i>
                  <span>
                    <strong>Outlet Basic Info</strong>
                  </span>
                </Card.Header>
                <Card.Body>
                  <div className="row">
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField label="Outlet Name" name="outletName" />
                      <FormTextField label="Phone Number" name="addressPhone" />
                      <FormTextField label="Email" name="addressEmail" />
                      <FormSelectField
                        label="Currency"
                        name="currencyID"
                        options={currencyOptions}
                      />
                      <FormSelectField
                        label="Thermal Printer Size"
                        name="thermalPrinterSizeID"
                        options={[
                          { label: "58mm", value: 58 },
                          { label: "80mm", value: 80 },
                        ]}
                      />
                    </div>
                    <div className="col-sm-6 col-md-6 col-lg-6">
                      <FormTextField
                        label="Address"
                        name="address"
                        mapsButton
                        onMapsClick={() => {
                          setOpenSearchMapPlaces(true);
                        }}
                      />
                      <FormTextField label="City" name="city" />
                      <FormTextField label="Province / State" name="province" />
                      <FormSelectField
                        label="Country"
                        name="countryCode"
                        options={countryOptions}
                      />
                      <FormTextField label="Postal Code" name="postalCode" />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
          <DialogActions>
            <button
              type="button"
              className="btn btn-label-danger btn-md btn-pill btn-bold"
              onClick={onCloseDialog}
            >
              <i className="fas fa-window-close"></i>
              Cancel
            </button>
            <button
              type="submit"
              className="btn btn-success btn-md btn-pill btn-bold"
              disabled={isSubmitting}
            >
              <i className="fas fa-save"></i>
              Save
            </button>
          </DialogActions>
          <DialogLayout
            open={openSearchMapPlaces}
            title="Search Address on Maps"
            onCloseDialog={() => {
              setOpenSearchMapPlaces(false);
            }}
            maxWIdth="lg"
            minHeight={true}
          >
            <MapPlaces
              address={values.address}
              city={values.city}
              province={values.province}
              countryCode={values.countryCode}
              postalCode={values.postalCode}
              onPinLocation={(
                selectedFormattedAddress,
                selectedShortAddressComponents,
                selectedLongAddressComponents,
                selectedAddress,
                selectedCity,
                selectedProvince,
                selectedCountryCode,
                selectedPostalCode
              ) => {
                setFieldValue(`address`, selectedAddress);
                setFieldValue(`city`, selectedCity);
                setFieldValue(`province`, selectedProvince);
                setFieldValue(`countryCode`, selectedCountryCode);
                setFieldValue(`postalCode`, selectedPostalCode);
                setOpenSearchMapPlaces(false);
              }}
              onCloseDialog={() => {
                setOpenSearchMapPlaces(false);
              }}
            />
          </DialogLayout>
        </form>
      )}
    </Formik>
  );

  function setMasterData(currencies = [], countries = []) {
    let currencyOptionsTmp = [];
    let countryOptionsTmp = [];
    if (typeof currencies !== "undefined") {
      currencies.forEach((currency) => {
        currencyOptionsTmp.push({
          value: currency.ID,
          label: currency.currencyCode,
        });
      });
    }

    if (typeof countries !== "undefined") {
      countries.forEach((country) => {
        countryOptionsTmp.push({
          value: country.countryCode,
          label: country.countryName,
        });
      });
    }
    setCurrencyOptions(currencyOptionsTmp);
    setCountryOptions(countryOptionsTmp);
  }
};

export default OutletForm;
